import { create } from "zustand";
import { axiosBuyer } from "../utils/AxiosInstance";
import { getBuyerToken } from "../utils/helperFunction";

interface CartInterface {
  totalProductsInCart: number;
  fetchTotalProductsInCart: () => Promise<void>;
  setTotalProductsInCart: (total: number) => void;
  initializeCart: () => void;
}

export const useCartStore = create<CartInterface>((set) => {
  let initialized = false;

  return {
    totalProductsInCart: 0,
    fetchTotalProductsInCart: async () => {
      try {
        const tokens = getBuyerToken();
        const url = `${process.env.REACT_APP_WEB_API_BASE_URL}/v1/buyer/cart-total-items`;
        if (!tokens) {
          return;
        }
        const response = await axiosBuyer.get(url);

        if (response.data.status === 200) {
          set({ totalProductsInCart: response?.data?.data });
        }
      } catch {}
    },

    setTotalProductsInCart: (count) => {
      set({ totalProductsInCart: count });
    },

    initializeCart: () => {
      if (!initialized) {
        initialized = true;
        const store = useCartStore.getState();
        store.fetchTotalProductsInCart();
      }
    },
  };
});
